import { createReducer } from '@reduxjs/toolkit';
import {
  DOWNLOAD_MESSAGE_DETAILS,
  DOWNLOAD_MESSAGE_DETAILS_FAIL,
  DOWNLOAD_MESSAGE_DETAILS_SUCCESS
} from '../actions.common';

type MessageDetailsDownloadStatus = 'pending' | 'success' | 'fail';

export interface MessageDetailsDownloadsState {
  isMessageDetailsDownloading: boolean;
  data: Record<string, MessageDetailsDownloadStatus>;
}

export const messageDetailsDownloadsInitialState: MessageDetailsDownloadsState = {
  isMessageDetailsDownloading: false,
  data: {}
};

export const messageDetailsDownloadsReducer = createReducer(messageDetailsDownloadsInitialState, {
  [DOWNLOAD_MESSAGE_DETAILS]: (state, action) => {
    state.isMessageDetailsDownloading = true;
    state.data[action.payload.id] = 'pending';
  },
  [DOWNLOAD_MESSAGE_DETAILS_SUCCESS]: (state, action) => {
    state.isMessageDetailsDownloading = false;
    state.data[action.payload.id] = 'success';
  },
  [DOWNLOAD_MESSAGE_DETAILS_FAIL]: (state, action) => {
    state.isMessageDetailsDownloading = false;
    state.data[action.payload.id] = 'fail';
  }
});

export default messageDetailsDownloadsReducer;
